import { usePermissions } from "react-admin";
import { hasPermission, hasAnyPermission, getScope, hasPartnerScope } from "@/utils/permissions";

export const useResourcePermissions = (resource: string) => {
  const { permissions, isLoading } = usePermissions();

  return {
    canList: hasPermission(permissions, resource, "list"),
    canShow: hasPermission(permissions, resource, "show"),
    canCreate: hasPermission(permissions, resource, "create"),
    canEdit: hasPermission(permissions, resource, "edit"),
    canDelete: hasPermission(permissions, resource, "delete"),
    hasAnyPermission: hasAnyPermission(permissions, resource),
    isLoading,
    permissions, // Expose full permissions for custom checks
    // Scope accessors — used for scope-aware UI decisions
    editScope: getScope(permissions, resource, "edit"),
    deleteScope: getScope(permissions, resource, "delete"),
    createScope: getScope(permissions, resource, "create"),
    hasPartnerList: hasPartnerScope(permissions, resource, "list"),
    hasPartnerEdit: hasPartnerScope(permissions, resource, "edit"),
    hasPartnerDelete: hasPartnerScope(permissions, resource, "delete"),
    listScope: getScope(permissions, resource, "list"),
  };
};
